<template>
  <div class="modal fade" id="modalDeleteBlocked" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Excluir CPF/CNPJ</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Você realmente deseja excluir da lista o<br />
            <span v-if="text.length == 11">CPF <b>{{ text | VMask('###.###.###-##') }}</b></span>
            <span v-else>CNPJ <b>{{ text | VMask('##.###.###/####-##') }}</b></span>
          ID:[{{id}}]
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
          <button ref="btnDelete" @click="deleteBlocked()" type="button" class="btn btn-outline-danger">Excluir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDeleteBlocked',

  props: ['id', 'text', 'modal'],

  methods: {
    async deleteBlocked() {
      this.$refs.btnDelete.innerText = 'Excluindo...'
      this.$refs.btnDelete.disabled = true

      await this.$api.delete(`/blockeds/${this.id}`)
      .then((response) => {
        this.$toastr.s('CPF/CNPJ excluído com sucesso!', 'Sucesso')
        this.$parent.$parent.blockeds = this.$parent.$parent.blockeds.filter((obj) => obj.id !== response.data.blocked.id)
        this.closeModalDelete()
      })
      .catch((err) => {
        this.$toastr.e(err.response.data.message, 'Erro')
      })
      .finally(() => {
        this.$refs.btnDelete.innerText = 'Excluir'
        this.$refs.btnDelete.disabled = false
      })
    },

    closeModalDelete() {
      this.modal.hide()
    }
  }
}
</script>

<style>
</style>